import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PeriodService {
  constructor(private http: HttpClient) {}

  public getMonthsClosedPeriod(): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + '/period/closed')
      .pipe(
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public closePeriod(monthsNumbers: number[]): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/period/close', { months: monthsNumbers })
      .pipe(
        catchError((error) => {
          return throwError(error);
        })
      );
  }
}